import {useState} from "react";
import {Button, Stack, TextField} from "@mui/material";
import Typography from "@mui/material/Typography";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import {z} from "zod";
import {hasFormChanged, zodSubmit} from "../../../utils/FormUtils";
import DisabledWrapper from "../../../components/DisabledWrapper";

const schema = z.object({
    last_name: z.string().min(1, "A vezetéknév kötelező"),
    first_name: z.string().min(1, "A keresztnév kötelező"),
    title: z.string().min(1, "A titulus/foglalkozás kötelező"),
});

const OwnData = ({data, handleSubmit}) => {
    const [errors, setErrors] = useState({});
    const [isDirty, setIsDirty] = useState(false);
    return (
        <form
            onSubmit={e => setIsDirty(!zodSubmit(e, setErrors, handleSubmit, schema))}
            onChange={e => setIsDirty(hasFormChanged(e.currentTarget, data))}
        >
            <Stack spacing={1} marginTop={2} marginBottom={2}>

                <Typography variant='caption' color='primary.main'>
                    Vezetéknév*
                </Typography>
                <TextField
                    name='last_name'
                    variant='standard'
                    defaultValue={data.last_name}
                    error={!!errors.last_name}
                    helperText={errors.last_name}
                />

                <Typography variant='caption' color='primary.main'>
                    Keresztnév*
                </Typography>
                <TextField
                    name='first_name'
                    variant='standard'
                    defaultValue={data.first_name}
                    error={!!errors.first_name}
                    helperText={errors.first_name}
                />

                <Typography variant='caption' color='primary.main'>
                    Titulus/Foglalkozás*
                </Typography>
                <TextField
                    name='title'
                    variant='standard'
                    defaultValue={data.title}
                    error={!!errors.title}
                    helperText={errors.title}
                />

            </Stack>
            <DisabledWrapper disabledCause={[{
                disabled: !isDirty,
                message: 'Módosítsd a mezőket a mentéshez!'
            }]}>
                <Button
                    endIcon={<SaveRoundedIcon/>}
                    type="submit"
                    variant='contained'
                >
                    Módosítások mentése
                </Button>
            </DisabledWrapper>

        </form>
    );
};

export default OwnData;
